export enum AnswerValueType {
  HEIGHT_FT = 'height_ft',
  WEIGHT_LB = 'weight_lb',
  HEIGHT_CM = 'height_cm',
  WEIGHT_KG = 'weight_kg',
}
